import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';

import User from 'entity/User';
import {
  GetUserMessage,
  IncomingMessageType,
  OutgoingMessageType,
  IncomingMessage,
  UserMessage,
} from 'messages/websocket.messages';

import { WebsocketService } from './websocket.service';

@Injectable()
export class QAService {
  private userCache = new Map<string, User>();

  public constructor(private websocketService: WebsocketService) {}

  public destroy() {
    this.userCache.clear();
  }

  /**
   * Toaster parameters - configure message and colors
   * @param userId - User id to get info
   * @param socialId - Optional SocialId to update cache in specific situations
   *
   * Case the socialId is informed, and the cached user have a different socialId saved,
   * we will ignore the cache and request the updated information from the websocket.
   */
  public getUser(userId: string, socialId?: string): Observable<User> {
    let user = this.userCache.get(userId);

    if (user) {
      if (socialId && socialId === user.socialId) {
        return of(user);
      }
    }

    const msg: GetUserMessage = {
      t: OutgoingMessageType.GET_USER,
      userId,
    };
    const isUserResponse = (rsp: IncomingMessage) => rsp.t === IncomingMessageType.USER && rsp.userId === userId;

    return this.websocketService.sendMessageAndAwaitResponse(msg, isUserResponse).pipe(
      map((rsp) => {
        user = (rsp as UserMessage).user;
        this.userCache.set(userId, user);
        return user;
      }),
    );
  }
}
